export const name = 'ApprovalRequests';

export const FETCH_DETAIL_APPROVAL_REQUESTS = `${name}/FETCH_DETAIL_APPROVAL_REQUESTS`;
export const FETCH_DETAIL_APPROVAL_REQUESTS_SUCCESS = `${name}/FETCH_DETAIL_APPROVAL_REQUESTS_SUCCESS`;
export const FETCH_DETAIL_APPROVAL_REQUESTS_FAILURE = `${name}/FETCH_DETAIL_APPROVAL_REQUESTS_FAILURE`;



// WEBPACK FOOTER //
// ./src/sites/approvalRequests/constants.js